module.exports = __webpack_public_path__ + "static/media/est.0fbfbf24.svg";